/**
 * BuildingSign - carved, architecture-integrated sign board for Thornhaven's
 * live/interactable buildings. A dark timber board with a gold frame and
 * engraved serif lettering (drei <Text>, local Cinzel font). Can be wall-fixed
 * or hung from a bracket. Function label is passed in via `label`.
 */

import { Text } from '@react-three/drei';
import { TH_STYLE, SIGN_FONT } from './thornhavenStyle';

export function BuildingSign({
  label,
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  width = 3,
  height = 0.85,
  fontSize = 0.34,
  hanging = false,
}) {
  return (
    <group position={position} rotation={rotation}>
      {hanging && (
        <group>
          {/* bracket arm into the wall */}
          <mesh position={[0, height / 2 + 0.45, -0.18]} castShadow>
            <boxGeometry args={[0.1, 0.1, 0.45]} />
            <meshStandardMaterial color={TH_STYLE.timberTrim} roughness={0.8} />
          </mesh>
          <mesh position={[0, height / 2 + 0.62, 0.02]} castShadow>
            <boxGeometry args={[width * 0.75, 0.1, 0.1]} />
            <meshStandardMaterial color={TH_STYLE.timberTrim} roughness={0.8} />
          </mesh>
          {/* hanging chains */}
          {[-width / 2 + 0.35, width / 2 - 0.35].map((x, i) => (
            <mesh key={i} position={[x, height / 2 + 0.3, 0]} castShadow>
              <cylinderGeometry args={[0.025, 0.025, 0.55, 6]} />
              <meshStandardMaterial color={TH_STYLE.goldDark} metalness={0.6} roughness={0.4} />
            </mesh>
          ))}
        </group>
      )}

      {/* board */}
      <mesh castShadow receiveShadow>
        <boxGeometry args={[width, height, 0.14]} />
        <meshStandardMaterial color={TH_STYLE.door} roughness={0.85} />
      </mesh>
      {/* gold outer frame */}
      <mesh position={[0, 0, 0.072]}>
        <boxGeometry args={[width - 0.1, height - 0.1, 0.03]} />
        <meshStandardMaterial color={TH_STYLE.gold} metalness={0.6} roughness={0.35} />
      </mesh>
      {/* recessed inner panel */}
      <mesh position={[0, 0, 0.085]}>
        <boxGeometry args={[width - 0.26, height - 0.26, 0.02]} />
        <meshStandardMaterial color="#1a110a" roughness={0.9} />
      </mesh>
      {/* engraved gold lettering */}
      <Text
        position={[0, 0, 0.12]}
        font={SIGN_FONT}
        fontSize={fontSize}
        color={TH_STYLE.gold}
        anchorX="center"
        anchorY="middle"
        maxWidth={width - 0.4}
        textAlign="center"
        letterSpacing={0.04}
        outlineWidth={0.006}
        outlineColor="#000000"
      >
        {label}
      </Text>
    </group>
  );
}

export default BuildingSign;
